import { http } from '../request'
import type { OperatorInfo } from './shared'

type ActivateResponse = {
  id: number
  name: string
  status: string
  activatedAt: string
  activatedBy: OperatorInfo
  activationVersionId?: number
  effectiveFromDate?: string | null
  effectiveToDate?: string | null
  groupCount?: number
  memberCount?: number
  offeringCount?: number
  lessonInstanceCount?: number
}

type DeactivateResponse = {
  id: number
  status: string
  deactivatedAt: string
}

type ActivateRequest = {
  mode?: 'FUTURE_ONLY' | 'RANGE_OVERWRITE'
  effectiveFromDate?: string
  effectiveToDate?: string
  confirmPresetOverwrite?: boolean
  confirmResourceConflict?: boolean
  validationToken?: string
}

type ActivationValidationResult = {
  canActivate: boolean
  checks: Array<{ name: string; passed: boolean; message: string }>
  summary: string
  scopeViolations: Array<{
    taskActivityId: number | null
    occurrenceIndex: number | null
    classId: number | null
    dayOfWeek: number | null
    startPeriod: number | null
    duration: number | null
    invalidSlotKeys: string[]
    message: string
  }>
  presetOverlaps: Array<{
    classId: number | null
    schoolDate: string
    periodNo: number
    existingLessonInstanceId: number | null
    existingActivationVersionId: number | null
    existingTaskId: number | null
    incomingTaskActivityId: number | null
    incomingOccurrenceIndex: number | null
    message: string
  }>
  resourceConflicts: Array<{
    conflictType: 'teacher' | 'room' | string
    resourceId: number | null
    schoolDate: string
    periodNo: number
    existingLessonInstanceId: number | null
    existingActivationVersionId: number | null
    existingTaskId: number | null
    incomingTaskActivityId: number | null
    incomingOccurrenceIndex: number | null
    message: string
  }>
  validationToken?: string | null
}

export const activationApi = {
  async validateForActivate(taskId: number): Promise<ActivationValidationResult> {
    const response = await http.get<ActivationValidationResult>(
      `/schedule/tasks/${taskId}/activate/validate`
    )
    return response.data
  },

  async activateTask(taskId: number, payload?: ActivateRequest): Promise<ActivateResponse> {
    const response = await http.post<ActivateResponse>(
      `/schedule/tasks/${taskId}/activate`,
      payload
    )
    return response.data
  },

  async deactivateTask(taskId: number): Promise<DeactivateResponse> {
    const response = await http.post<DeactivateResponse>(
      `/schedule/tasks/${taskId}/deactivate`
    )
    return response.data
  }
}
